import { addressRepository } from '~/api/repository/address';

export const ADDRESS_QUERY_KEY = {
  all: ['address'] as const,

  // 배송지 목록
  list: () => ({
    queryKey: [...ADDRESS_QUERY_KEY.all, 'list'] as const,
    queryFn: () => addressRepository.getShippingAddresses(),
  }),

  // 기본 배송지
  default: () => ({
    queryKey: [...ADDRESS_QUERY_KEY.all, 'default'] as const,
    queryFn: () => addressRepository.getDefaultShippingAddress(),
  }),
};
